module.exports = __webpack_public_path__ + "static/media/lambda-door-lp-vector.bf47a8d2.svg";